import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router/index.js'
import { initTheme } from './theme.js'
import { refreshSession } from './auth.js'
import './style.css'

initTheme()

const app = createApp(App)

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  const forbiddenLogAttributes = new Set([
    'access_token',
    'amount',
    'authorization',
    'bearer_token',
    'password',
    'request_body',
    'response_body',
    'token',
  ])

  Sentry.init({
    app,
    dsn: sentryDsn,
    enableLogs: true,
    sendDefaultPii: true,
    beforeSendLog(log) {
      for (const key of Object.keys(log.attributes ?? {})) {
        if (forbiddenLogAttributes.has(key.toLowerCase())) {
          delete log.attributes[key]
        }
      }

      return log
    },
  })
}

app.use(router).mount('#app')

// Slide the session forward on every visit; not awaited so the first render
// is never blocked by the network.
refreshSession().then((result) => {
  if (result === 'unauthorized') {
    router.replace({ name: 'login' })
  }
})
